<template>
  <div
    :data-test="dataTest"
    :class="`callout--${severity}`"
    class="py-4 px-3 d-flex"
    @click="$emit('click')">
    <div class="flex-grow-0 mr-2">
      <FontIcon
        class="flex-grow-0 callout__icon"
        iconClass="fa-exclamation-triangle" />
    </div>
    <div class="flex-grow-1">
      <div class="font-weight-semibold callout__main-text">
        <slot />
      </div>
      <div class="callout__additional-text">
        <slot name="additional" />
      </div>
    </div>
    <button
      v-if="showCloseButton"
      type="button"
      data-test="callout-close-button"
      class="ml-4 close flex-grow-2"
      @click="$emit('closeCallout')">
      <span>&times;</span>
    </button>
  </div>
</template>

<script>
import FontIcon from './FontIcon'

/**
 *
 * @deprecated Use CoreAlert instead
 */
const coreCallout = {
  name: 'CoreCallout',
  components: {FontIcon},
  emits: ['click', 'closeCallout'],
  props: {
    dataTest: {
      type: String,
      required: true,
    },
    severity: {
      type: String,
      validator (value) {
        return ['danger', 'warning', 'info', 'success'].includes(value)
      },
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
  },
}

export default coreCallout
</script>

<style scoped lang="scss">
@mixin generateCalloutVariant($severityName, $background, $border, $fontColor) {
  .callout--#{$severityName} {
    background: $background;
    border: 1px solid $border;

    .callout__main-text, .callout__icon {
      color: $fontColor;
    }
  }
}

@include generateCalloutVariant('info', $blue-background, $blue-light, $blue-dark);
@include generateCalloutVariant('warning', $yellow-background, $yellow-light, $yellow-dark);
@include generateCalloutVariant('danger', $red-background, $red-light, $red-dark);
@include generateCalloutVariant('success', $green-background, $green-light, $green-dark);
</style>
